export const TEMPLATE_LIMIT = 18;

export const MASONRY_BREAKPOINTS = {
  default: 3,
  2560: 6,
  2240: 5,
  1920: 4,
  1600: 3,
  1280: 2,
};

export const MASONRY_BREAKPOINTS_RELATED_TEMPLATES = {
  default: 4,
  2560: 6,
  2240: 5,
  1920: 4,
  1600: 4,
  1280: 3,
};

export const SCENE_PREVIEW_DIMENSIONS = {
  '16:9': {
    height: 50,
    width: 89,
  },
  '1:1': {
    height: 50,
    width: 50,
  },
  '9:16': {
    height: 60,
    width: 34,
  },
};
